<mat-icon [matTooltip]="country?.Name" fontSet="flag-icon" [fontIcon]="'flag-icon-' + country?.Code | lowercase" style="min-height:24px;min-width:24px"></mat-icon>
